import {
  FETCH_NOTICED_ARTICLES,
  NOTICED_ARTICLES_FULFILLED,
  FETCH_NOTICED_ARTICLES_ERROR,
  
  CREATE_REPORT,
  CREATE_REPORT_SUCCESS,
  CREATE_REPORT_ERROR,
  
  FETCH_REPORTS,
  FETCH_REPORTS_SUCCESS,
  FETCH_REPORTS_ERROR,

  DELETE_REPORT,
  DELETE_REPORT_ERROR,
  DELETE_REPORT_SUCCESS,

  GET_ITEMS_ID_NOTICED,
  GET_ITEMS_ID_NOTICED_SUCCESS,
  GET_ITEMS_ID_NOTICED_ERROR,

  UPDATE_ITEMS_NOTICED,
  UPDATE_ITEMS_NOTICED_SUCCESS,
  UPDATE_ITEMS_NOTICED_ERROR,

  GET_REPORT_DATA,
  GET_REPORT_DATA_SUCCESS,
  GET_REPORT_DATA_ERROR,

} from "redux/actions/noticedArticles";

import { SITE_ID_TO_COUNTRY_NAME } from 'helpers/normalizeReportDataArticle';

import { 
  createReportError, 
  fetchReportsError,
  deleteReportError,
  createReportSuccess, 
  deleteReportOptimistic,
  fetchNoticedArticlesError,
  fetchNoticedArticlesSuccess,
} from 'redux/reducers/utils/noticedArticles';


const initialState = {
  count: 0,
  reports: [],
  isLoading: false,
  noticedArticles: [],
  creatingReport: false,
  isLoadingReports: false,
  // review
  optimisticErrorData: {},
  noticedArticlesTotal: 0,
  noticedArticlesFrom: null,
  optimisticDataIndex: null,

  isLoadingGetItemsIDNoticed: false,
  isLoadingUpdateItemsNoticed: false,
  itemsNoticedReport: [],
  updatedItemsNoticedReport: []
};

export default (state = initialState, action) => {
  switch (action.type) {
  case FETCH_NOTICED_ARTICLES:
    return {
      ...state,
      isLoading: true,
      noticedArticles: action.payload.from ? 
        state.noticedArticles : [],
    };

  case NOTICED_ARTICLES_FULFILLED:
    return fetchNoticedArticlesSuccess(
      state,
      action.payload
    );
 
  case FETCH_NOTICED_ARTICLES_ERROR:
    return fetchNoticedArticlesError(
      state,
      action.payload
    );

  case CREATE_REPORT:
    return {
      ...state,
      creatingReport: true,
    };

  case CREATE_REPORT_SUCCESS: 
    return createReportSuccess(state);
    
  case CREATE_REPORT_ERROR:
    return createReportError(
      state,
      action.payload
    );
  
  case FETCH_REPORTS: 
    return {
      ...state,
      isLoadingReports: !action.payload.silent,
    };

  case FETCH_REPORTS_SUCCESS: 
    return {
      ...state,
      reports: action.payload,
      isLoadingReports: false,
    };

  case FETCH_REPORTS_ERROR:
    return fetchReportsError(
      state,
      action.payload
    );

  case DELETE_REPORT:
    return deleteReportOptimistic(
      state,
      action.payload,
    );

  case DELETE_REPORT_SUCCESS:
    return {
      ...state,
      isLoadingReports: false,
    };

  case DELETE_REPORT_ERROR: 
    return deleteReportError(state);
  
  case GET_ITEMS_ID_NOTICED: 
    return {
      ...state,
      itemsNoticedReport: [],
      isLoadingGetItemsIDNoticed: true,
    };

  case GET_ITEMS_ID_NOTICED_SUCCESS: 
    return {
      ...state,
      itemsNoticedReport: action.payload.getItemsIDNoticed.articleIds,
      isLoadingGetItemsIDNoticed: false,
    };    
    
  case GET_ITEMS_ID_NOTICED_ERROR: 
    return {
      ...state,      
      itemsNoticedReport: [],
      isLoadingGetItemsIDNoticed: false,
    };    

  case UPDATE_ITEMS_NOTICED: 
    return {
      ...state,
      updatedItemsNoticedReport: [],
      isLoadingUpdateItemsNoticed: true,
    };

  case UPDATE_ITEMS_NOTICED_SUCCESS: 
    return {
      ...state,
      updatedItemsNoticedReport: action.payload.updateItemsNoticed.articles,
      isLoadingUpdateItemsNoticed: false,
    };    
    
  case UPDATE_ITEMS_NOTICED_ERROR: 
    return {
      ...state,
      updatedItemsNoticedReport: [],
      isLoadingUpdateItemsNoticed: false,
    };

  case GET_REPORT_DATA:
    return {
      ...state,
      updatedItemsNoticedReport: [],
      isLoadingUpdateItemsNoticed: true,
    };

  case GET_REPORT_DATA_SUCCESS: {
    const articles = action.payload?.getReportData?.articles ?? [];
    const enriched = articles.map(article => {
      const siteId = article.item_id ? article.item_id.substring(0, 3) : null;
      const countryName = (siteId && SITE_ID_TO_COUNTRY_NAME[siteId]) || siteId || '';
      return { ...article, siteId, countryName };
    });
    return {
      ...state,
      updatedItemsNoticedReport: enriched,
      isLoadingUpdateItemsNoticed: false,
    };
  }

  case GET_REPORT_DATA_ERROR:
    return {
      ...state,
      updatedItemsNoticedReport: [],
      isLoadingUpdateItemsNoticed: false,
    };

  default:
    return state;
  }
};